export default __webpack_public_path__ + "static/media/play_pressed.dbca7293.png";